// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { IndicesQuoteModule } from './app.module';
bootstrapAppModule(IndicesQuoteModule);
